// extracted by mini-css-extract-plugin
export default {"item":"SecondaryNav_item__v9hbl"};